var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as baobab from '@data/baobab/baobab';
import { useEffect, useState } from 'react';
export default function useSimulationData(simCols, simRows, simValues, wId) {
    var _a = __read(useState([]), 2), rowDataTags = _a[0], setRowDataTags = _a[1];
    var _b = __read(useState([]), 2), colDataTags = _b[0], setColDataTags = _b[1];
    var _c = __read(useState(null), 2), data = _c[0], setData = _c[1];
    useEffect(function () {
        setRowDataTags(simRows.map(function (row) {
            return row.sourceVersionTagId ? __spreadArray(__spreadArray([], __read(row.tagIds), false), [row.sourceVersionTagId], false) : row.tagIds;
        }));
    }, [simRows]);
    useEffect(function () {
        setColDataTags(simCols.map(function (col) { return col.tagIds; }));
    }, [simCols]);
    useEffect(function () {
        if (simRows.length > 0 && simCols.length > 0) {
            baobab.root.select('state', 'widgetsLoading', wId).set(true);
            var dataGrid_1 = [];
            simRows.forEach(function (row, rIdx) {
                var rdt = rowDataTags[rIdx] || [];
                var rowData = [];
                simCols.forEach(function (col, cIdx) {
                    var cdt = colDataTags[cIdx] || [];
                    var string = getTagIdsArrString(__spreadArray(__spreadArray([], __read(rdt), false), __read(cdt), false));
                    var value = simValues[string] !== undefined ? simValues[string] : null;
                    rowData.push({ value: value, key: string });
                });
                dataGrid_1.push(rowData);
            });
            if (JSON.stringify(data) !== JSON.stringify(dataGrid_1)) {
                setData(dataGrid_1);
            }
            baobab.root.select('state', 'widgetsLoading', wId).set(false);
        }
    }, [simRows, simCols, rowDataTags, colDataTags, simValues]);
    return data;
}
function getTagIdsArrString(arr) {
    return "".concat(arr.sort(function (a, b) { return a - b; }).join(','));
}
